import React from "react";
import { useNavigate } from "react-router-dom";
import { EndpointPathNames } from "@/shared/config/endpoint-path";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { useModalContext } from "@/shared/components/modal/contexts/modal-context";
import { usePutUsers } from "@/features/user/hooks/use-put-users";
import { useLoginContext } from "@/features/auth/contexts/login-context";


interface Props {
  onTapCloseModal: () => void;
}

export const ConfirmNotConvertModal = ({ onTapCloseModal }: Props) => {
  const navigate = useNavigate();
  const {
    setOpenNotLoginModal,
  } = useModalContext();
  const { soriId } = useLoginContext();
  const { putUsers } = usePutUsers();

  const continueRegisterWithoutConvert = async (soriId: string) => {
    await putUsers(soriId);
    setOpenNotLoginModal(undefined);
    navigate(EndpointPathNames.FIRST_AUTH + "?legal=1");
  };

  return (
      <BasePageModal
        title=""
        handleClose={() => {
          onTapCloseModal();
        }}
        bottomChildren={
          <>
          <BaseRoundButton
            buttonText="はい"
            onClick={() => continueRegisterWithoutConvert(soriId)}
          />
          <BaseRoundButton
            buttonText="いいえ"
            onClick={() => onTapCloseModal()}
          />
          </>
        }
        disableOverlayClose={true}
      >
        <>
          <p>Web版の利用を開始すると、今までご利用の「MoneyLink」は利用できなくなります。</p>
          <p>データを引き継がないでWeb版の利用を開始してよろしいですか？</p>
        </>
      </BasePageModal>
  );
};